<template>
  <div class="basic_editor">
    <div style="margin-top: 10px">
      <Toolbar
        :editorId="editorId"
        :editor="editorRef"
        :defaultConfig="toolbarConfig"
        :mode="mode"
        style="border: 1px solid #ccc"
      />
      
      <Editor
        :editorId="editorId"
        class="editor"
        :defaultConfig="editorConfig"
        :mode="mode"
        v-model="valueHtml"
        @onCreated="handleCreated"
        @onChange="handleChange"
        @customPaste="customPaste"
      />
      <div class="hideSource" style="display: none">
        <textarea v-model="valueHtml"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadImg, removeImages, uploadFile } from "network/upload.js";
import { ElMessage, ElMessageBox } from "element-plus";
import { imgUploadVerif, fileUploadVerif } from "common/utils";
import "@wangeditor/editor/dist/css/style.css";
import {
  onBeforeUnmount,
  ref,
  shallowRef,
  onMounted,
  reactive,
  toRefs,
  nextTick,
} from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { menusource } from "./insertToolbar";
import { Boot } from "@wangeditor/editor";
import attachmentModule from "@wangeditor/plugin-upload-attachment";
// 注册。要在创建编辑器之前注册，且只能注册一次，不可重复注册。
Boot.registerModule(attachmentModule);
export default {
  props: {
    isDecode:{
      //是否编解码
      type:Boolean,
      default:true,
    },
    content: String,
    editorId: {
      type: String,
      default: function () {
        return (
          "editor-" + +new Date() + ((Math.random() * 1000).toFixed(0) + "")
        );
      },
    },
    type: Number,
  },
  components: { Editor, Toolbar },
  emits: {
    "change-content": null,
  },
  setup(props, { emit }) {
    const data = reactive({
      showCode: false,
      filesUploadList: [], //新增图片
      imgList1: [], //上传的图片数组
      imgList2: [], //当前实际html内的图片
    });
    // 编辑器实例，必须用 shallowRef，重要！
    const editorRef = shallowRef();
    // 获取父组件props
    const propsData = JSON.parse(JSON.stringify(props));
    //解决 decodeURICompnent解码后的加号问题
    let contentHtml = "";
    contentHtml = propsData.content.replace(/\+/g, " ");
    // 内容 HTML
    const valueHtml = ref(null);
    const toolbarConfig = {
      insertKeys: {
        index: 0, // 插入的位置，基于当前的 toolbarKeys
        keys: ["menusource", "uploadAttachment"],
      },
      // 隐藏的工具栏 代码块和上传视频
      excludeKeys: [
        "codeBlock",
        "codeSelectLang",
        "code",
        "insertVideo",
        "uploadVideo",
        "group-video",
      ],
    };
    const editorConfig = {
      placeholder: "请输入内容...",
      MENU_CONF: {
        // 在编辑器中，点击选中“附件”节点时，要弹出的菜单
        hoverbarKeys: {
          attachment: {
            menuKeys: ["downloadAttachment"], // “下载附件”菜单
          },
        },
      },
    };
    //图片上传
    editorConfig.MENU_CONF["uploadImage"] = {
      // 上传图片的配置
      // 自定义上传
      async customUpload(file, insertFn) {
        // 1.file 即选中的文件 2.实现上传请求接口，并得到图片 url alt href 3.最后插入图片
        const fd = new FormData();
        fd.append("file", file);
        uploadImg(fd, 1).then((res) => {
          if (res.code==1) {
            data.imgList1.push(res.result.fileData.src);
            insertFn(res.result.fileData.src,res.result.fileData.title, null);
          } else {
            ElMessage.error(res.message);
          }
        });
      },
      
    };
    
    // “上传附件”菜单的配置
    editorConfig.MENU_CONF["uploadAttachment"] = {
      async customUpload(file, insertFn) {
        // 文件校验
        if (!fileUploadVerif(file)) {
          ElMessage.error(
            '只允许上传后缀名为["doc", "docx", "xlsx", "pdf"]的附件'
          );
          return false;
        }
        const fd = new FormData();
        fd.append("file", file);
        uploadFile(fd, 1).then((res) => {
          // 如果上传成功
          if (res.result.fileData.src) {
            // res为图片服务器返回的数据
            insertFn(file.name,res.result.fileData.src, null);
          } else {
            ElMessage.error(res.message);
          }
        });
      },
    };
  

    // 模拟 ajax 异步获取内容
    onMounted(() => {
      nextTick(() => {
        valueHtml.value = contentHtml;
      });
    });

    // 组件销毁时，也及时销毁编辑器，重要！
    onBeforeUnmount(() => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    });
   

    // 编辑器回调函数
    const handleCreated = (editor) => {
      editorRef.value = editor; // 记录 editor 实例，重要！
    };
    const handleChange = (editor) => {
      
      // let dom = Array.prototype.slice.call( editor.getEditableContainer().querySelectorAll("img"));
      // if (dom) {
      //     try {
      //       // 对dom数组进行循环,
      //       dom.map((x, index) => {
      //         let elem = document.createElement('a')
      //         elem.className = `img${index}`;
      //         let domA = editor.getEditableContainer().querySelector(`.img${index}`)
      //         // 没有绑定链接and有链接，包裹a标签
      //         if(!domA && dom[index].dataset.href != 'null' && dom[index].dataset.href != 'undefined' && dom[index].dataset.href){
      //           if ((x = dom[index])) {
      //             dom[index].parentNode.replaceChild(elem,dom[index])
      //             elem.appendChild(dom[index])
      //             elem.href = decodeURIComponent(dom[index].dataset.href) 
      //           }
      //         }
              
      //       });
      //     } catch (e) {
      //       console.log(e);
      //       return e;
      //     }
      //   }
        let content = editor.getHtml();
        emit("change-content", content);
    };


    // // 自定义上传文件行为
    // const fileUploadAction = (file, insertFn) => {};
    // 粘贴
    const customPaste = (editor, event, callback) => {
      //  console.log("ClipboardEvent 粘贴事件对象", event);
      const html = event.clipboardData.getData('text/html') // 获取粘贴的 htm
      if(!html){
        const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
        editor.insertText(text)
      }else{
        editor.dangerouslyInsertHtml(html)
        
      }
      
         
      // 返回 false ，阻止默认
      event.preventDefault();
      callback(false); // 返回值（注意，vue 事件的返回值，不能用 return）
    };

    const printHtml = () => {
      const editor = editorRef.value;
      if (editor == null) return;
    };

    const disable = () => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.disable();
    };

    return {
      ...toRefs(data),
      editorRef,
      mode: "default",
      valueHtml,
      toolbarConfig,
      editorConfig,
      handleCreated,
      handleChange,
      customPaste,
      printHtml,
      disable,
      
    };
  },
};
</script>
<style >
.basic_editor{
  width: 100%;
}
.w-e-full-screen-container {
  z-index: 9999;
}
.w-e-modal .babel-container span {
  margin-bottom: 0;
}
.w-e-modal .babel-container {
  margin-bottom: 0;
}
.w-e-bar-item {
  height: 44px !important;
}
.w-e-text-placeholder {
  top: 7px !important;
}
.editor {
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  height: 340px !important;
}

.hideSource textarea {
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  width: 100%;
  height: 340px;
  outline: none;
}

.w-e-full-screen-container .hideSource {
  height: 100%;
}
.w-e-full-screen-container .hideSource textarea {
  height: 100%;
}


.table-container table tbody th {
  background-color: transparent !important;
}
.table-container table tbody th {
  border-right: 0 !important;
}
.table-container table tbody th:last-child {
  border-right: 1px solid var(--w-e-textarea-border-color) !important;
}
.w-e-modal {
  top: 0 !important;
  bottom: 0 !important;
  height: 310px !important;
}
.table-container table tbody td {
  text-align: center !important;
}
/* .w-e-text-container .w-e-scroll{
  height: 100% !important; min-height: 340px !important;overflow-y: scroll !important;
}

.w-e-text-container{
  min-height: 340px !important;
} */

</style>
